import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { showNotification } from "../../utils";
import "react-notifications-component/dist/theme.css";
import ClosedIcon from "../../assets/icons/colored/ClosedIcon.svg";
import OpenedIcon from "../../assets/icons/colored/OpenedIcon.svg";
import "./pace.css";

const TreeNode = ({ label, children, isOpen, toggleNode, hasChildren }) => {
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div
        onClick={hasChildren ? toggleNode : null}
        style={{
          cursor: hasChildren ? "pointer" : "default",
          display: "flex",
        }}
      >
        {hasChildren && (
          <img
            src={isOpen ? OpenedIcon : ClosedIcon}
            alt={isOpen ? "Opened" : "Closed"}
            style={{ marginRight: 8 }} // Espacio entre el icono y el texto
          />
        )}
        <span style={{ fontWeight: "bold" }}>{label}:</span>
      </div>
      {isOpen && hasChildren && (
        <div style={{ marginLeft: 20 }}>{children ? children : "No visto"}</div>
      )}
      {!hasChildren && (
        <div style={{ alignItems: "center", marginLeft: 28, color: "black" }}>
          {children}
        </div>
      )}
    </div>
  );
};

const TreeView = ({ data, expandedAll, infoDetails }) => {
  const renderLeaf = (value) => {
    if (typeof value === "number") {
      const detail = infoDetails.find((d) => d.id === value);
      if (detail) {
        return (
          <div className="pace_table">
            <table>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Start Date</th>
                  <th>Teacher ID</th>
                  <th>First Name</th>
                  <th>Paternal Last Name</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{value}</td>
                  <td>
                    {new Date(detail.startDate).toLocaleString("es-ES", {
                      weekday: "long",
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: false,
                    })}
                  </td>
                  <td>{detail.teacherId}</td>
                  <td>{detail.firstName}</td>
                  <td>{detail.paternalLastName}</td>
                </tr>
              </tbody>
            </table>
          </div>
        );
      }
      return <div>{value}</div>;
    } else {
      return (
        <div>{value === null || value === "" ? "No visto" : String(value)}</div>
      );
    }
  };

  const renderTree = (obj) => {
    return Object.keys(obj).map((key, index) => {
      const value = obj[key];
      const hasChildren = value !== null && typeof value === "object";
      return (
        <TreeNodeWrapper
          key={index}
          label={key}
          expandedAll={expandedAll}
          hasChildren={hasChildren}
        >
          {hasChildren ? renderTree(value) : renderLeaf(value)}
        </TreeNodeWrapper>
      );
    });
  };

  return <div>{renderTree(data)}</div>;
};

const TreeNodeWrapper = ({ label, children, expandedAll, hasChildren }) => {
  const [isOpen, setIsOpen] = useState(expandedAll);

  useEffect(() => {
    setIsOpen(expandedAll);
  }, [expandedAll]);

  const toggleNode = () => setIsOpen(!isOpen);

  return (
    <TreeNode
      label={label}
      isOpen={isOpen}
      toggleNode={toggleNode}
      hasChildren={hasChildren}
    >
      {children}
    </TreeNode>
  );
};

const Pace = () => {
  const defaultUser = {
    customer_id: "",
    customer_id_type: "",
    first_name: "",
    middle_name: "",
    maternal_last_name: "",
    paternal_last_name: "",
    contract_expiration: "",
    monthly_intensity: "",
    block_acc: "",
    email: "",
    roles: [],
  };
  const [customerID, setCustomerID] = useState("");
  const [userData, setUserData] = useState(defaultUser);
  const [responseData, setResponseData] = useState(null);
  const [notFound, setNotFound] = useState(false); // Estado para manejar el id no encontrado
  const [expandedAll, setExpandedAll] = useState(false);
  const [activeTab, setActiveTab] = useState("active");

  const navigate = useNavigate();

  const handleSearch = () => {
    var getPaceUrl = `${process.env.REACT_APP_API_URL}/api/v1/pace/student/progress`;
    fetch(getPaceUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + Cookies.get("token"),
      },
      body: JSON.stringify({ customer_id: customerID }),
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().then((data) => {
            throw new Error(data.message);
          });
        } else if (response.status === 200) {
          showNotification(
            "¡Datos!",
            "Informacion del Pace cargada",
            "success"
          );
          return response.json();
        }
      })
      .then((data) => {
        setResponseData(data);
        setNotFound(false);
        setExpandedAll(false);
        setActiveTab("active");
      })
      .catch((error) => {
        showNotification("Error", error.message, "warning");
        setResponseData(null);
        setNotFound(true); // Establecer "id no encontrado" en verdadero
      });
  };

  const handleClear = () => {
    setCustomerID(""); // Borra el customerID
    setResponseData(null); // Borra los datos de respuesta
  };

  const expandAll = () => setExpandedAll(true);
  const collapseAll = () => setExpandedAll(false);

  return (
    <div className="pace_container">
      <div className="pace_show">
        <h1>Buscar PACE de Estudiante</h1>
        <input
          type="text"
          placeholder="Ingrese el ID"
          value={customerID}
          onChange={(e) => setCustomerID(e.target.value)}
        />
        <div className="pace_submit_container">
          <input
            className="pace_search-button"
            type="button"
            value="Buscar"
            onClick={handleSearch}
          />
          <input
            className="pace_clear-button"
            type="button"
            value="Borrar"
            onClick={handleClear}
          />
        </div>
        {notFound && <p>ID No encontrado</p>}

        {responseData && responseData.active_paces?.length > 0 && (
          <div className="pace_tabs">
            <input
              className="pace_ac_finished-button"
              type="button"
              value="Pace Activo"
              onClick={() => setActiveTab("active")}
            />
          </div>
        )}

        {responseData && activeTab === "active" && responseData.active_paces?.length > 0 && (
          <div className="pace_info-tables">
            {responseData.active_paces.map((pace, index) => (
              <div key={index}>
                <h3>Programa: {pace.program}</h3>
                <p>Lenguaje: {pace.language}</p>
                <p>Nivel: {pace.level}</p>
                <h4>Progreso:</h4>
                <div className="pace_expand_collapse_buttons">
                  <button
                    className="pace_expand_collapse_button_expand"
                    onClick={expandAll}
                  >
                    Expandir Todo
                  </button>
                  <button
                    className="pace_expand_collapse_button_contra"
                    onClick={collapseAll}
                  >
                    Contraer Todo
                  </button>
                </div>
                <TreeView
                  data={pace.content_progress}
                  expandedAll={expandedAll}
                  infoDetails={responseData.info_details}
                />
                <h4>Ausencias:</h4>
                <table>
                  <thead>
                    <tr>
                      <th>Talleres</th>
                      <th>Sesion Regular</th>
                      <th>Examen</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        {pace.absences.workshops.length > 0 ? (
                          <p>
                            Id de las sesiones:{" "}
                            {pace.absences.workshops.join(", ")}
                          </p>
                        ) : (
                          "No hay ausencias"
                        )}
                      </td>
                      <td>
                        {pace.absences.regular_sessions.length > 0 ? (
                          <p>
                            Id de los talleres:{" "}
                            {pace.absences.regular_sessions.join(", ")}
                          </p>
                        ) : (
                          "No hay ausencias"
                        )}
                      </td>
                      <td>
                        {pace.absences.exams &&
                        pace.absences.exams.length > 0 ? (
                          <p>
                            Id de los examenes:{" "}
                            {pace.absences.exams.join(", ")}
                          </p>
                        ) : (
                          "No hay ausencias"
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <h4>Abordaje:</h4>
                {pace.approach?.regular_sessions?.length > 0 ? (
                  <p>
                    Id de las sesiones:{" "}
                    {pace.approach.regular_sessions.join(", ")}
                  </p>
                ) : (
                  <p>No hay abordaje</p>
                )}
              </div>
            ))}
          </div>
        )}

        {responseData &&
          !responseData.active_paces?.length &&
          !responseData.finished_paces?.length && (
            <p>No hay datos disponibles</p>
          )}
      </div>
    </div>
  );
};

export default Pace;
